<template>
<div class="page-wrapper">
  <v-layout align-center >
    <v-flex xs12 sm10 md8 lg6>
      <form v-scroll-to-error @submit.prevent="submitForm">
        <v-layout wrap>
          <v-flex xs12>
            <div v-if="$apollo.loading">
              <spinner />
            </div>
            <div v-else>
              <div class="title-screen">
                <span>Event conference info</span>
              </div>
              <conference-data-form
                :initial-values="form"
                :vs="$v"
                @values="form = $event"
              />
              <main-button
                text="Update"
                depressed
                @click="$emit('submit')"
              />
            </div>
          </v-flex>
        </v-layout>
      </form>
    </v-flex>
    <simple-snackbar
      :open.sync="snackbar"
      color="primary"
      message-prop="Conference details saved"
    />
  </v-layout>
  </div>
</template>

<script>
import { url } from 'vuelidate/lib/validators'

import { GET_EVENT_CONFERENCE_DATA, UPDATE_EVENT_CONFERENCE_DATA } from '../../graphql/event.graphql'
import SimpleSnackbar from '../shared/snackbars/simple-snackbar'
import ConferenceDataForm from './event-conference-data-form'
import { submitGuard } from '../../utils'

export default {
  name: 'event-conference-data-container',
  components: { ConferenceDataForm, SimpleSnackbar },
  props: {
    eventId: {
      type: String,
      default: null,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        aboutUs: { url },
        partners: { url },
      },
    }
  },
  data() {
    return {
      form: {
        primaryColor: '#0277BD',
        secondaryColor: '#FF4C00',
      },
      snackbar: false,
    }
  },
  methods: {
    async submitForm() {
      await submitGuard(this, async () => {
        const { id, ...input } = this.form

        await this.$apollo.mutate({
          mutation: UPDATE_EVENT_CONFERENCE_DATA,
          variables: {
            eventId: this.eventId,
            input,
          },
        })
        this.snackbar = true
      })
    },
  },
  apollo: {
    getEventConferenceData: {
      query: GET_EVENT_CONFERENCE_DATA,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({ data: { getEventConferenceData: conferenceData }, loading }) {
        if (!loading) {
          if (!conferenceData) return
          const { primaryColor, secondaryColor, ...rest } = conferenceData

          this.form = {
            primaryColor: primaryColor || '#0277BD',
            secondaryColor: secondaryColor || '#FF4C00',
            ...rest,
          }
        }
      },
    },
  },
}
</script>

<style scoped>
@media screen and (max-width: 800px) {
  .page-wrapper{
    margin-top: 1.5rem
  }
}
</style>
